import { HTML5Backend } from 'react-dnd-html5-backend'
import { IS_TIP_TAP_EDITING } from '../components/entities/Text'

// https://github.com/react-dnd/react-dnd/issues/802#issuecomment-1872949603
const ModifiedBackend = (...args) => {
  // @ts-ignore
  const instance = new HTML5Backend(...args)

  const listeners = [
    'handleTopDragStart',
    'handleTopDragStartCapture',
    'handleTopDragEndCapture',
    'handleTopDragEnter',
    'handleTopDragEnterCapture',
    'handleTopDragLeaveCapture',
    'handleTopDragOver',
    'handleTopDragOverCapture',
    'handleTopDrop',
    'handleTopDropCapture',
  ]

  listeners.forEach(name => {
    const original = instance[name]
    instance[name] = (e: any, ...extraArgs: any) => {
      if (!window[IS_TIP_TAP_EDITING]) {
        original(e, ...extraArgs)
      }
    }
  })

  return instance
}

// Decorate root elements with this
export { ModifiedBackend }
